import { Injectable } from '@angular/core';
import * as series from "../../config/series";

@Injectable({
  providedIn: 'root'
})
export class BaseGaugeService {

  constructor() { }
  getDefaultOption() {
    let param={
      series:series.getGaugeSeries({min:0,max:100,data:0,colorRange: [
        [0.3, '#67e0e3'],
        [0.7, '#37a2da'],
        [1, '#fd666d']
      ]})
    }
    return param;
  }
  setDatas(option: any, datas: any) {
    option.series = series.getGaugeSeries(datas);
  }
}
